import { render, staticRenderFns } from "./latestOffers.vue?vue&type=template&id=797b4d41&scoped=true"
import script from "./latestOffers.vue?vue&type=script&lang=js"
export * from "./latestOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b4d41",
  null
  
)

export default component.exports